import version from "@/lib/version"

export const appVersion = version

// Set at build time — defaults to '' for local dev
export const publicUrl = import.meta.env.REACT_APP_PUBLIC_URL || ""

// Endpoint for external Upload service
export const uploadServiceEndpoint =
  import.meta.env.REACT_APP_UPLOAD_SERVICE || `/upload/v1`

/**
 * Builds a relative path to our BFF (Express) API.
 *
 * Unlike CRA, Vite does not support proxying via package.json.
 * Instead, Vite handles API proxies through vite.config.mjs — this function ensures
 * paths resolve correctly both in development (via Vite proxy) and in production (via base URL).
 *
 * Note: Avoid using window.location.origin — axios handles the base automatically.
 */
export const buildApiUrl = (path) =>
  `/${publicUrl}${path}`.replace(/\/{2,}/g, "/")